module.exports = __webpack_public_path__ + "static/img/ts-icon.948c86e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ts-icon.png
// module id = n/LW
// module chunks = 3